<app-control-layout 
    [control]="formCtrl"
    [label]="label"
    [ignoreLabel]="ignoreLabel"
    [labelBlock]="labelBlock"
    [labelOpacity]="labelOpacity"
    [width]="width"
    [maxLength]="maxLength"
    [attr.id] ="idName">
    <form class="input-form" [style.width]="labelBlock ? 'calc(100% - 140px)' : width">
        <div class="input-group" [ngClass]="{'align-items-center': mode==='edit' && !fileUploadedAgain, 'justify-content-between': mode==='edit' && !fileUploadedAgain}">
            <div *ngIf="mode==='edit' && !fileUploadedAgain" class="filename" data-toggle="tooltip" data-placement="top" [title]="fileName">{{fileName}}</div>
            <input type="file" [hidden]="mode==='edit' && !fileUploadedAgain" id="file-input" class="form-control" name="file-input" #input>
            <div class="input-group-append">
                <button type="button" class="btn btn-secondary browse-button" [attr.disabled]="disabled" (click)="fileSelector()">
                    {{ mode !=='edit' ? 'Browse' : 'Upload new file'}}
                </button>
            </div>
        </div>
    </form>
</app-control-layout>
<div class="additional-text-container" *ngIf="additionalTextLine1 || additionalTextLine2 || additionalTextLine3">
    <div *ngIf="additionalTextLine1" class="text-right text-muted">{{ additionalTextLine1 }}</div>
    <div *ngIf="additionalTextLine2" class="text-right text-muted">{{ additionalTextLine2 }}</div>
    <div *ngIf="additionalTextLine3" class="text-right text-muted">{{ additionalTextLine3 }}</div>
</div>